<section class="topbar-container z-30">
    @if (introFinished) {
        <app-header [isScrolled]="isScrolled || isDetailPage" (searchRecommender)="onSearch()"></app-header>
    }
</section>

<main id="agmo-main-content" class="main-content" [class.no-footer-padding]="hideFooter">
    <div class="main-inner">
        <router-outlet></router-outlet>

        @if (showCompareProduct) {
            <app-selected-compare-product class="fixed bottom-0 w-full z-50"></app-selected-compare-product>
        }
    </div>

    @if (!hideFooter) {
        <app-footer class="footer" ngSkipHydration></app-footer>
    }
</main>

@if (introFinished) {
    <div class="floating-button-container">
        <a
            href="https://api.whatsapp.com/send/?phone=6596477131&text&type=phone_number&app_absent=0"
            target="_blank"
            class="icon-[3rem] md:icon-[4.125rem] bg-icon-whatsapp">
        </a>

        <button type="button" class="group search-recommender">
            <div class="icon-[3rem] md:icon-[4.125rem] bg-icon-search-recommender"></div>
            <span
                translate
                class="recommender-text opacity-0 translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300"
                (click)="onSearch()">
                Recommender
            </span>
        </button>
    </div>
}
